// pt-BR da página Agentes e modelos (decisão D20, fatia L1b-ii); completo para toda chave de en-agents.ts (checado pelo tipo).
import type { enAgents } from "./en-agents.ts";

export const ptBRAgents: Record<keyof typeof enAgents, string> = {
  "agents.learnings.independent.latest": "Última revisão independente: {decision}",
  "agents.learnings.independent.decision.approve": "Aprovado",
  "agents.learnings.independent.decision.reject": "Rejeitado",
  "agents.learnings.independent.decision.defer": "Adiado",
  "agents.learnings.independent.reviewer": "Revisor: {reviewer}",
  "agents.learnings.independent.model": "Modelo configurado: {model}",
  "agents.learnings.independent.provenance": "Proveniência da revisão",
  "agents.learnings.independent.notRecorded": "Não registrado",
  "agents.learnings.independent.reviewId": "ID da revisão",
  "agents.learnings.independent.learningVersion": "Versão do aprendizado revisada",
  "agents.learnings.independent.reviewedAt": "Revisado em",
  "agents.learnings.independent.reviewerId": "ID do perfil do revisor",
  "agents.learnings.independent.reviewerVersion": "ID da versão do revisor",
  "agents.learnings.independent.modelCall": "ID da chamada de modelo registrada",
  "agents.learnings.independent.evidenceFingerprint": "Impressão digital das evidências",
  "agents.learnings.independent.evidence": "Referências de evidências",
  "agents.learnings.independent.sourceRun": "ID da execução de origem",
  "agents.learnings.independent.sourceAttempt": "ID da tentativa de origem",
  "agents.learnings.independent.candidate": "Hash do candidato revisado",
  "agents.learnings.independent.unavailable": "O histórico de revisões independentes está indisponível.",
  "agents.learnings.independent.window": "Os detalhes mostram a revisão independente mais recente de cada aprendizado visível.",
  "agents.detail.actor.user": "Pessoa",
  "agents.detail.actor.agent": "Agente de IA",
  "agents.detail.actor.service": "IA / serviço",
  "agents.detail.actor.system": "Sistema",
  "agents.detail.actor.integration": "Integração",
  "agents.detail.actor.unknown": "Autor desconhecido",
  "agents.sections": "Seções de agentes",
  "agents.tab.registry": "Agentes",
  "agents.tab.learnings": "Aprendizados",
  "agents.tab.scores": "Notas e recomendações",
  "agents.tab.config": "Modelos e cotas",
  "agents.subtitle.registry": "Os agentes que trabalham nas suas tarefas: o que cada um faz, a versão em uso e os resultados medidos.",
  "agents.subtitle.learnings": "O que os agentes aprenderam, por projeto e por agente. Nada chega a um prompt sem revisão.",
  "agents.subtitle.scores": "Resultados medidos por versão de agente e o que melhorar em seguida. Quem decide são as pessoas; nada muda sozinho.",

  "agents.origin.all": "Todos",
  "agents.origin.platform": "Modelo da plataforma",
  "agents.origin.organization": "Da organização",

  "agents.registry.search": "Buscar agentes",
  "agents.registry.searchPlaceholder": "Nome, chave ou especialidade...",
  "agents.registry.role": "Papel",
  "agents.registry.allRoles": "Todos os papéis",
  "agents.registry.originFilter": "Filtrar por origem",
  "agents.registry.sync": "Sincronizar catálogo",
  "agents.registry.syncHint": "Traz os agentes da plataforma e os pacotes de conhecimento desta versão. Agentes editados na sua organização nunca são sobrescritos.",
  "agents.registry.synced": "Catálogo {version} sincronizado: {created} criados, {updated} atualizados, {unchanged} sem mudança, {available} com atualização para revisar, {conflicts} conflitos de chave. Aprendizados importados: {learnings}.",
  "agents.registry.syncFailed": "Não foi possível sincronizar o catálogo",
  "agents.registry.loading": "Carregando agentes",
  "agents.registry.loadFailed": "Não foi possível carregar os agentes",
  "agents.registry.emptyTitle": "Nenhum agente ainda",
  "agents.registry.emptyBody": "Sincronize o catálogo da plataforma para adicionar os agentes pré-configurados: orquestrador, planejador, desenvolvedores, QA e revisores.",
  "agents.registry.emptyBodyMember": "Um administrador da organização pode sincronizar o catálogo da plataforma para adicionar os agentes pré-configurados.",
  "agents.registry.noMatchTitle": "Nenhum agente corresponde aos filtros",
  "agents.registry.clearFilters": "Limpar filtros",
  "agents.registry.count": "{n} agentes exibidos",

  "agents.card.open": "Abrir {name}",
  "agents.card.version": "v{n}",
  "agents.card.noVersion": "sem versão",
  "agents.card.project": "Agente do projeto",
  "agents.card.updateAvailable": "Atualização do catálogo disponível ({version})",
  "agents.card.updateAvailableHint": "Este agente foi editado na sua organização, então a nova versão do catálogo não foi aplicada. Revise antes de atualizar.",

  "agents.score.value": "{score}/100",
  "agents.score.detail": "limite inferior {bound} · {runs} execuções",
  "agents.score.insufficient": "Amostra insuficiente ({runs}/{min} execuções)",
  "agents.score.none": "Sem execuções em {days} dias",
  "agents.score.unavailable": "Notas indisponíveis",

  "agents.detail.loading": "Carregando o agente",
  "agents.detail.loadFailed": "Não foi possível carregar o agente",
  "agents.detail.facts": "Dados do agente",
  "agents.detail.key": "Chave",
  "agents.detail.role": "Papel",
  "agents.detail.origin": "Origem",
  "agents.detail.state": "Estado",
  "agents.detail.version": "Versão atual",
  "agents.detail.scope": "Disponível para",
  "agents.detail.orgWide": "Toda a organização",
  "agents.detail.catalog": "Catálogo",
  "agents.detail.update": "Atualização do catálogo",
  "agents.detail.score": "Resultados medidos ({days} dias)",
  "agents.detail.description": "Quando usar",
  "agents.detail.instructions": "Instruções",
  "agents.detail.instructionsHint": "As regras comuns da plataforma entram antes destas instruções quando o agente roda.",
  "agents.detail.specialties": "Especialidades",
  "agents.detail.delegatesTo": "Delega para",
  "agents.detail.consultsTo": "Consulta",
  "agents.detail.memoryScopes": "Aprendizados que lê",
  "agents.detail.tools": "Ferramentas",
  "agents.detail.grants": "Operações de integração",
  "agents.detail.grant": "cartão {card}, permissão: {permission}",
  "agents.detail.none": "Nenhum",
  "agents.detail.versions": "Versões",
  "agents.detail.versionItem": "Versão {n}",
  "agents.detail.versionCurrent": "atual",
  "agents.detail.noteEmpty": "Sem nota de mudança",
  "agents.detail.versionTools": "{tools} ferramentas · {grants} operações de integração",
  "agents.permission.ler": "leitura",
  "agents.permission.enviar": "envio",

  "agents.scope.agent_project": "Agente no projeto",
  "agents.scope.project": "Projeto",
  "agents.scope.agent": "Agente",
  "agents.scope.organization": "Organização",
  "agents.scope.platform": "Plataforma",

  "agents.kind.structure_issue": "Problema de estrutura",
  "agents.kind.practice": "Boa prática",
  "agents.kind.pitfall": "Armadilha",
  "agents.kind.procedure": "Procedimento",
  "agents.kind.preference": "Preferência",
  "agents.kind.fact": "Fato",

  "agents.status.proposed": "Para revisar",
  "agents.status.approved": "Aprovado",
  "agents.status.rejected": "Rejeitado",
  "agents.status.deprecated": "Descontinuado",
  "agents.status.superseded": "Substituído",

  "agents.learnings.filters": "Filtrar aprendizados",
  "agents.learnings.status": "Situação",
  "agents.learnings.allStatuses": "Todas as situações",
  "agents.learnings.scope": "Escopo",
  "agents.learnings.allScopes": "Todos os escopos",
  "agents.learnings.kind": "Tipo",
  "agents.learnings.allKinds": "Todos os tipos",
  "agents.learnings.search": "Buscar aprendizados",
  "agents.learnings.searchPlaceholder": "Palavras do título ou do texto...",
  "agents.learnings.new": "Novo aprendizado",
  "agents.learnings.readOnly": "Só administradores e mantenedores da organização revisam aprendizados.",
  "agents.learnings.loading": "Carregando aprendizados",
  "agents.learnings.loadFailed": "Não foi possível carregar os aprendizados",
  "agents.learnings.emptyTitle": "Nenhum aprendizado aqui",
  "agents.learnings.emptyBody": "Os agentes propõem aprendizados ao terminar o trabalho; os pacotes de conhecimento revisados chegam com a sincronização do catálogo.",
  "agents.learnings.queueEmptyTitle": "Nada para revisar",
  "agents.learnings.queueEmptyBody": "As novas propostas dos agentes aparecem aqui antes de chegar a qualquer prompt.",
  "agents.learnings.count": "{n} aprendizados exibidos",
  "agents.learnings.tainted": "Veio de conteúdo externo — revise com atenção",
  "agents.learnings.taintedHint": "O agente leu uma página web, um e-mail ou uma mensagem ao produzir este aprendizado: ele pode trazer instruções plantadas por terceiros.",
  "agents.learnings.confidence": "Confiança {value}",
  "agents.learnings.uses": "Usado {retrieved}× · ajudou {helpful} · atrapalhou {harmful}",
  "agents.learnings.source.agent_run": "Proposto por um agente",
  "agents.learnings.source.human": "Escrito por uma pessoa",
  "agents.learnings.source.knowledge_pack": "Pacote de conhecimento {pack}",
  "agents.learnings.createdAt": "Criado em {when}",
  "agents.learnings.expires": "Expira em {when}",
  "agents.learnings.approve": "Aprovar",
  "agents.learnings.reapprove": "Aprovar de novo",
  "agents.learnings.reject": "Rejeitar",
  "agents.learnings.deprecate": "Descontinuar",
  "agents.learnings.actionLabel": "{action}: {title}",

  "agents.review.title.approve": "Aprovar aprendizado",
  "agents.review.title.reject": "Rejeitar aprendizado",
  "agents.review.title.deprecate": "Descontinuar aprendizado",
  "agents.review.body.approve": "Aprendizados aprovados entram nos prompts dos agentes do escopo, marcados com a origem.",
  "agents.review.body.reject": "Aprendizados rejeitados nunca são usados. O registro fica guardado para auditoria.",
  "agents.review.body.deprecate": "Aprendizados descontinuados deixam de ser usados. Dá para aprovar de novo depois.",
  "agents.review.note": "Nota para a auditoria",
  "agents.review.noteHint": "Nunca inclua dados pessoais ou credenciais.",
  "agents.review.confirm.approve": "Aprovar",
  "agents.review.confirm.reject": "Rejeitar",
  "agents.review.confirm.deprecate": "Descontinuar",
  "agents.review.done.approve": "Aprendizado aprovado.",
  "agents.review.done.reject": "Aprendizado rejeitado.",
  "agents.review.done.deprecate": "Aprendizado descontinuado.",

  "agents.newLearning.title": "Novo aprendizado",
  "agents.newLearning.description": "Uma lição que ajuda os agentes em tarefas futuras. Fica visível para todos os membros e agentes do escopo: nada de dados pessoais nem credenciais.",
  "agents.newLearning.scope": "Vale para",
  "agents.newLearning.scope.project": "Um projeto (todos os agentes)",
  "agents.newLearning.scope.agent_project": "Um agente em um projeto",
  "agents.newLearning.scope.agent": "Um agente (todos os projetos)",
  "agents.newLearning.scope.organization": "Toda a organização",
  "agents.newLearning.kind": "Tipo",
  "agents.newLearning.project": "Projeto",
  "agents.newLearning.agent": "Agente",
  "agents.newLearning.choose": "Escolha...",
  "agents.newLearning.titleField": "Título",
  "agents.newLearning.titleHint": "Curto e específico (3 a 160 caracteres).",
  "agents.newLearning.body": "Lição",
  "agents.newLearning.bodyHint": "O que fazer ou evitar, e por quê (3 a 4000 caracteres).",
  "agents.newLearning.expires": "Expira em",
  "agents.newLearning.expiresHint": "Depois desta data o aprendizado deixa de ser usado, a menos que seja confirmado de novo.",
  "agents.newLearning.submit": "Salvar aprendizado",
  "agents.newLearning.required": "Escolha uma opção",
  "agents.newLearning.tooShort": "Escreva pelo menos 3 caracteres",
  "agents.newLearning.doneApproved": "Aprendizado salvo e aprovado.",
  "agents.newLearning.doneProposed": "Aprendizado salvo; ele aguarda revisão.",
  "agents.newLearning.duplicate": "Este aprendizado já existe neste escopo; nada foi adicionado.",

  "agents.scores.window": "Período",
  "agents.scores.days": "{n} dias",
  "agents.scores.title": "Notas por versão",
  "agents.scores.hint": "Calculadas a partir das tentativas encerradas no período. A nota aparece quando a versão tem execuções suficientes; o limite inferior evita que amostras pequenas pareçam melhores do que são.",
  "agents.scores.loading": "Carregando notas",
  "agents.scores.loadFailed": "Não foi possível carregar as notas",
  "agents.scores.emptyTitle": "Nenhum resultado no período",
  "agents.scores.emptyBody": "As notas aparecem depois que os agentes concluem tentativas em tarefas.",
  "agents.scores.tableLabel": "Notas por versão de agente",
  "agents.scores.col.agent": "Agente",
  "agents.scores.col.version": "Versão",
  "agents.scores.col.runs": "Execuções",
  "agents.scores.col.success": "Sucesso",
  "agents.scores.col.bound": "Limite inferior",
  "agents.scores.col.firstPass": "De primeira",
  "agents.scores.col.interventions": "Ajuda humana",
  "agents.scores.col.rework": "Retrabalho",
  "agents.scores.col.cost": "Custo médio",
  "agents.scores.col.duration": "Tempo médio",
  "agents.scores.col.score": "Nota",
  "agents.scores.unversioned": "antes das versões",
  "agents.scores.unknown": "desconhecido",
  "agents.scores.unknownAgent": "Agente não visível",

  "agents.recs.title": "Recomendações",
  "agents.recs.hint": "Calculadas a partir das notas e dos aprendizados que aguardam revisão. Aceitar registra a sua decisão; quem altera os agentes continuam sendo as pessoas.",
  "agents.recs.readOnly": "Só administradores e mantenedores da organização decidem recomendações.",
  "agents.recs.loading": "Carregando recomendações",
  "agents.recs.loadFailed": "Não foi possível carregar as recomendações",
  "agents.recs.emptyTitle": "Nenhuma recomendação",
  "agents.recs.emptyBody": "Nada precisa de atenção neste período.",
  "agents.recs.kind.update_agent": "Atualizar agente",
  "agents.recs.kind.create_agent": "Criar agente",
  "agents.recs.kind.promote_version": "Promover versão",
  "agents.recs.kind.retire_agent": "Aposentar agente",
  "agents.recs.kind.review_learning": "Revisar aprendizado",
  "agents.recs.status.open": "Em aberto",
  "agents.recs.status.accepted": "Aceita",
  "agents.recs.status.dismissed": "Dispensada",
  "agents.recs.subject.area": "Tipo de tarefa: {area}",
  "agents.recs.evidence": "Evidências",
  "agents.recs.decidedAt": "Decidida em {when}",
  "agents.recs.accept": "Aceitar",
  "agents.recs.dismiss": "Dispensar",
  "agents.recs.actionLabel": "{action}: {kind}",
  "agents.recs.done.accept": "Recomendação aceita.",
  "agents.recs.done.dismiss": "Recomendação dispensada.",
};
